import React from 'react';
import FreelancerPageApp, { FreelancerPageAppProps } from '../../../apps/freelancer_page/entry';

const FreelancerPageClient = (props: Omit<FreelancerPageAppProps, 'entryType'>) => (
    <FreelancerPageApp {...props} entryType="client" />
);

export default FreelancerPageClient;
